export default "__VITE_ASSET__D8r5WOy9__"